<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Leere Featuresysteme löschen' | translate }}</div>
  <dx-switch [(value)]="deleteFeatureSystems"></dx-switch>
</div>

<div class="dx-field">
    <div class="dx-field-label w-50">{{ 'Leere Werte auch bei Variantenmerkmalen löschen.' | translate }}</div>
    <dx-switch [(value)]="deleteInVariantFeatureSystem"></dx-switch>
</div>

<div class="dx-field">
    <div class="dx-field-label w-50">{{ 'Masterprodukte von Funktion ausschließen' | translate }}</div>
    <dx-switch [(value)]="ignoreMasterProducts"></dx-switch>
</div>